<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-guide"></i>
              后处理工艺管理
            </h1>
            <p class="page-subtitle">管理后期处理工艺配置，包含工艺类型、计算方式和规格参数</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加后期工艺" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()"></el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item>
                <el-input v-model="searchCondition.follow_craft_name" placeholder="请输入后处理名称" clearable prefix-icon="el-icon-guide">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
        <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="60" align="center" label="排序">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="拖动排序" placement="top">
                  <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.pid" :data-depth="scope.row.depth">
                    <i class="el-icon-rank"></i>
                  </span>
                </el-tooltip>
              </template>
          </el-table-column>

            <el-table-column width="60" label="序号" align="center">
            <template slot-scope="scope">
                <span class="sequence-number">{{ scope.row.follow_craft_rank}}</span>
            </template>
          </el-table-column>

            <el-table-column label="工艺信息" min-width="200">
            <template slot-scope="scope">
                <div class="craft-info">
                  <div class="info-row">
                    <i class="el-icon-guide"></i>
                    <span class="info-label">工艺名称：</span>
                    <span class="info-value">{{scope.row.follow_craft_name}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-menu"></i>
                    <span class="info-label">弹窗类型：</span>
                    <el-tag :type="getCraftTypeColor(scope.row.follow_craft_type)" size="mini">
                      {{getCraftTypeText(scope.row.follow_craft_type)}}
                    </el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">工艺描述：</span>
                    <el-tooltip :content="scope.row.follow_craft_desc" placement="top" :disabled="!scope.row.follow_craft_desc || scope.row.follow_craft_desc.length <= 30">
                      <span class="info-value desc-text">{{scope.row.follow_craft_desc | truncate(30)}}</span>
                    </el-tooltip>
                  </div>
                </div>
            </template>
          </el-table-column>

            <el-table-column label="工艺规格" min-width="180">
            <template slot-scope="scope">
                <div class="craft-specs">
                  <div class="specs-grid" v-if="scope.row.follow_craft_models">
                    <div class="spec-item" v-for="item in JSON.parse(scope.row.follow_craft_models)" :key="item.no">
                      <i class="el-icon-collection-tag"></i>
                      <span class="spec-key">{{item.key}}:</span>
                      <span class="spec-value">{{item.value}}</span>
                    </div>
                  </div>
                </div>
            </template>
          </el-table-column>
             
            <el-table-column label="计算配置" min-width="200">
            <template slot-scope="scope">
                <div class="calc-config">
                  <div class="info-row">
                    <i class="el-icon-s-finance"></i>
                    <span class="info-label">计算方式：</span>
                    <el-tag :type="getCostTypeColor(scope.row.cost_type)" size="mini">
                      {{getCostTypeText(scope.row.cost_type)}}
                    </el-tag>
                  </div>
                  <div class="calc-params" v-if="scope.row.cost_type !== '0'">
                    <div class="param-item" v-if="scope.row.cost_type === '1' && scope.row.cost_config">
                      <i class="el-icon-brush"></i>
                      <span>喷漆系数: {{JSON.parse(scope.row.cost_config).base_unit}}</span>
                      <span>基础费用: ¥{{JSON.parse(scope.row.cost_config).base_price}}</span>
                    </div>
                    <div class="param-item" v-if="scope.row.cost_type === '4' && scope.row.cost_config">
                      <i class="el-icon-brush"></i>
                      <span>打磨单价: ¥{{JSON.parse(scope.row.cost_config).base_price}}</span>
                    </div>
                  </div>
                </div>
            </template>
          </el-table-column>
           
            <el-table-column label="状态设置" width="120" align="center">
            <template slot-scope="scope">
                <div class="status-settings">
                  <div class="status-item">
                    <span class="status-label">启用状态</span>
                    <el-switch 
                      v-model="scope.row.follow_craft_status" 
                      :active-value="'1'" 
                      :inactive-value="'0'" 
                      active-color="#67c23a" 
                      inactive-color="#f56c6c" 
                      @change="changeRow(scope.row)">
                    </el-switch>
                  </div>
                  <div class="status-item">
                    <span class="status-label">需要文件</span>
                    <el-switch 
                      v-model="scope.row.must_be_file" 
                      :active-value="'1'" 
                      :inactive-value="'0'" 
                      active-color="#67c23a" 
                      inactive-color="#f56c6c" 
                      @change="changeRow(scope.row)">
                    </el-switch>
                  </div>
                </div>
            </template>
          </el-table-column>
           
            <el-table-column v-if="buttonType=='icon'" width="100" label="操作" align="center">
            <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑工艺" placement="top">
                    <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="editButton(scope.row.id)"></el-button>
              </el-tooltip>
                </div>
            </template>
          </el-table-column>
        </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="11">
              <el-form-item label="后处理名称" prop="follow_craft_name">
                <el-input v-model="formData.follow_craft_name" prefix-icon="el-icon-guide"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="弹窗类型" prop="follow_craft_type">
                <el-select v-model="formData.follow_craft_type" placeholder="请选择">
                  <el-option label="去支撑" value="1"></el-option>
                  <el-option label="喷砂" value="2"></el-option>
                  <el-option label="攻牙" value="3"></el-option>
                  <el-option label="牙套" value="4"></el-option>
                  <el-option label="铜螺母" value="5"></el-option>
                  <el-option label="精打磨" value="6"></el-option>
                  <el-option label="喷漆" value="7"></el-option>
                  <el-option label="硬度" value="8"></el-option>
                  <el-option label="螺纹CNC" value="9"></el-option>
                  <el-option label="氧化CNC" value="10"></el-option>
                  <el-option label="喷砂CNC" value="11"></el-option>
                  <el-option label="配件CNC" value="12"></el-option>
                  <el-option label="装配CNC" value="13"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="是否启用" prop="follow_craft_status">
                <el-select v-model="formData.follow_craft_status" placeholder="请选择"> 
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="计算方式" prop="cost_type">
                <el-select v-model="formData.cost_type" placeholder="请选择" @change="changeCostType">
                  <el-option label="不用计算" value="0"></el-option>
                  <el-option label="喷漆" value="1"></el-option>
                  <el-option label="铜螺母/牙套" value="2"></el-option>
                  <el-option label="攻牙" value="3"></el-option>
                  <el-option label="精打磨" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="是否需要文件" prop="must_be_file">
                <el-select v-model="formData.must_be_file" placeholder="请选择">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="formData.cost_type=='1'">
            <el-col :span="11">
              <el-form-item label="喷漆系数" prop="cost_config.base_unit">
                <el-input v-model="formData.cost_config.base_unit" placeholder="请输入喷漆系数" prefix-icon="el-icon-s-data"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="基础调色费用" prop="cost_config.base_price">
                <el-input v-model="formData.cost_config.base_price" placeholder="请输入基础调色费用" prefix-icon="el-icon-coin">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="formData.cost_type=='4'">
            <el-col :span="22">
              <el-form-item label="精打磨单价" prop="cost_config.base_price">
                <el-input v-model="formData.cost_config.base_price" placeholder="请输入精打磨单价" prefix-icon="el-icon-coin">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="后处理描述" prop="follow_craft_desc">
                <el-input v-model="formData.follow_craft_desc" type="textarea" rows="3" placeholder="请输入后处理工艺描述"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="后处理规格描述" prop="follow_craft_spec_desc">
                <ApeEditor
                  :init-html="formData.follow_craft_spec_desc"
                  :editorHeight="480"
                  @handleTinymceInput="handleTinymceInput"
                ></ApeEditor>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="spec-section">
            <div class="spec-header">
              <i class="el-icon-plus" @click="addItem"></i>
              <span>添加后处理规格</span>
          </div>
            <el-table :data="formData.follow_craft_models" stripe class="spec-table">
            <el-table-column>
              <template slot-scope="scope">
                  <el-form class="spec-form" :inline="true">
                    <el-form-item label="规格名称">
                      <el-input v-model="scope.row.key" placeholder="请输入规格名称" /> 
                  </el-form-item>
                    <el-form-item label="规格值">
                      <el-input v-model="scope.row.value" placeholder="请输入规格值" /> 
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>    
              <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                  <el-tooltip effect="dark" content="删除规格" placement="top">
                    <i class="el-icon-delete delete-btn" @click="deleteItem(scope.$index)"></i>
                  </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          </div>
          <I18nTranslatePanel entity-type="follow_craft" :entity-id="formData.id || ''" />
        </el-form>     
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeEditor from '@/components/ApeEditor'
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import ApeUploader from '@/components/ApeUploader'
import { getFollowCraftTypeLabel } from '@/utils/followCraftTypeMap'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeEditor,
    ApeUploader,
    I18nTranslatePanel
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 10,
        query: "",
        order_by: 'follow_craft_rank asc',
        params: [],
      },
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        page_size: 10,
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        cost_config:{},
        follow_craft_models:[{key:'',value:''}],
        id:'',
      },
      // 表单验证
      rules: {
        follow_craft_name: [{required: true,message:'输入后期工艺名称', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '80%',
      },
      rolesList: [],
      userRoles: []
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  filters: {
    truncate(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  },
  methods: {
    // 获取工艺类型颜色
    getCraftTypeColor(type) {
      const colorMap = {
        '1': 'primary', '2': 'success', '3': 'warning', '4': 'danger',
        '5': 'info', '6': 'primary', '7': 'success', '8': 'warning',
        '9': 'danger', '10': 'info', '11': 'primary', '12': 'success',
        '13': 'warning'
      }
      return colorMap[type] || ''
    },
    // 获取工艺类型文本
    getCraftTypeText(type) {
      return getFollowCraftTypeLabel(type)
    },
    // 获取计算方式颜色
    getCostTypeColor(type) {
      const colorMap = {
        '0': 'info', '1': 'primary', '2': 'success', '3': 'warning', '4': 'danger'
      }
      return colorMap[type] || ''
    },
    // 获取计算方式文本
    getCostTypeText(type) {
      const textMap = {
        '0': '不用计算', '1': '喷漆', '2': '铜螺母/牙套', '3': '攻牙', '4': '精打磨'
      }
      return textMap[type] || ''
    },
    // 搜索
    searchButton() {
      this.searchCondition.query= ''
      this.searchCondition.params = []

      if (this.searchCondition.username != ''){
        this.searchCondition.query = ' instr(follow_craft_name,?)'
        this.searchCondition.params.push(this.searchCondition.username)
      }
      this.getList()
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    addItem() {
      this.formData.follow_craft_models.push({key:'',value:''})
    },
    handleTinymceInput(val) {
      this.formData.follow_craft_spec_desc = val;
    },
    deleteItem(item){
      this.formData.follow_craft_models.splice(item,1)
    },
    changeCostType(val){
      if(val=='0'){
        this.formData.cost_config = {
          base_unit: 600,
          base_price: 200,
        }
      } else if (val === '1') {
        this.formData.cost_config = this.normalizeCostConfig({
          base_unit: this.formData.cost_config && this.formData.cost_config.base_unit != null ? this.formData.cost_config.base_unit : 600,
          base_price: this.formData.cost_config && this.formData.cost_config.base_price != null ? this.formData.cost_config.base_price : 200,
        })
      } else if (val === '4') {
        this.formData.cost_config = this.normalizeCostConfig({
          base_price: this.formData.cost_config && this.formData.cost_config.base_price != null ? this.formData.cost_config.base_price : 0,
        })
      }
    },
    // el-input 常把数字存成字符串；提交前统一转成 number，避免后端 Unmarshal float64 失败
    normalizeCostConfig(cfg) {
      if (!cfg || typeof cfg !== 'object' || Array.isArray(cfg)) {
        return {}
      }
      const out = Object.assign({}, cfg)
      ;['base_price', 'base_unit'].forEach((key) => {
        if (out[key] === undefined || out[key] === null || out[key] === '') {
          return
        }
        const n = Number(out[key])
        if (!Number.isNaN(n)) {
          out[key] = n
        }
      })
      return out
    },
    stringifyCostConfig(cfg) {
      if (cfg instanceof Object) {
        return JSON.stringify(this.normalizeCostConfig(cfg))
      }
      if (typeof cfg === 'string') {
        try {
          return JSON.stringify(this.normalizeCostConfig(JSON.parse(cfg)))
        } catch (e) {
          return cfg
        }
      }
      return JSON.stringify({})
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
      this.formData.follow_craft_models = [{key:'',value:''}]
      this.formData.cost_config = {}
      this.formData.id = ''
    },
    async changeRow(row){
      this.formData = row
      let formData = this.formData
      if(this.formData.follow_craft_models instanceof Array){
        formData.follow_craft_models = JSON.stringify(this.formData.follow_craft_models)
      }
      if(this.formData.cost_config instanceof Object || typeof this.formData.cost_config === 'string'){
        formData.cost_config = this.stringifyCostConfig(this.formData.cost_config)
      }else if(this.formData.cost_config instanceof Array){
        formData.cost_config = JSON.stringify(this.formData.cost_config)
      }
      let res = await this.$api.post('/service/ola_app_follow_craft/update',this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')  
        this.initFormData()
      }else{
        this.$message.error(res.msg)
      }
      this.loadingStaus=false
      this.getList()
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(UID：'+id+')'
      let res = await this.$api.post('/service/ola_app_follow_craft/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
        this.formData.follow_craft_models = JSON.parse(this.formData.follow_craft_models)
        console.log(this.formData.follow_craft_models)
        try {
          const raw = typeof this.formData.cost_config === 'string'
            ? JSON.parse(this.formData.cost_config || '{}')
            : (this.formData.cost_config || {})
          this.formData.cost_config = this.normalizeCostConfig(raw)
        } catch (e) {
          this.formData.cost_config = {}
        }
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_follow_craft/create'
      if(this.formData.id!=''){
        url = '/service/ola_app_follow_craft/update'
      }
      let formData = Object.assign({}, this.formData)
      if(this.formData.follow_craft_models instanceof Array){
        formData.follow_craft_models = JSON.stringify(this.formData.follow_craft_models)
      }
      if(this.formData.cost_config instanceof Object || typeof this.formData.cost_config === 'string'){
        formData.cost_config = this.stringifyCostConfig(this.formData.cost_config)
      }else if(this.formData.cost_config instanceof Array){
        formData.cost_config = JSON.stringify(this.formData.cost_config)
      }
      let res = await this.$api.post(url,formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')  
      }else{
        this.$message.error(res.msg)
      }
      this.drawerData.loading = false
      this.drawerData.visible = false
      this.getList()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.follow_craft_status=='0'){
        row.follow_craft_status='1'
      }else{
        row.follow_craft_status='0'
      }
      let res = await this.$api.post('/service/ola_app_follow_craft/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')  
        this.initFormData()
      }else{
        this.$message.error(res.msg)
      }
      this.drawerData.loading = false
      this.getList()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteFollowCraft(id)
      if (info == null) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    async getFollowCraftPhasePrice(id) {
      window.open(this.$route.path+'/'+id+'/follow_craft_phase_price', '_blank');
    },
    // 初始化数据列表
    async getList() {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      Object.assign(this.searchCondition,pagingInfo)
      let res = await this.$api.post('/service/ola_app_follow_craft/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList = res.data.list
        this.pagingData.total = res.data.page.total
        this.offset = res.data.page.offset
      }
      this.loadingStaus=false
    },
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_follow_craft/order',{orderIds:orderIds,sort_field:'follow_craft_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.list()
      }else{
        this.$message.error('排序失败!')
      }
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle", 
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    }
  },
  mounted() {
    this.getList()
    this.$nextTick(() => {
      this.dragSort()
    })
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
      font-size 24px
      font-weight 600
      display flex
      align-items center
      
      i
        margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 拖拽排序样式
.drag-handle
  font-size 18px
  cursor move
  color #409eff
  
  &:hover
    color #66b1ff

// 工艺信息样式
.craft-info, .calc-config
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 70px
    
    .info-value
      color #303133
      font-weight 500
      
      &.desc-text
        line-height 1.4

// 工艺规格样式
.craft-specs
  .specs-grid
    display flex
    flex-wrap wrap
    gap 8px
    
    .spec-item
      display flex
      align-items center
      background #f5f7fa
      padding 4px 8px
      border-radius 6px
      font-size 11px
      
      i
        color #409eff
        margin-right 4px
        font-size 12px
      
      .spec-key
        color #909399
    margin-right 4px
        font-weight 500
      
      .spec-value
        color #303133
        font-weight 600

// 计算参数样式
.calc-params
  margin-top 8px
  
  .param-item
    display flex
    align-items center
    gap 8px
    font-size 11px
    color #606266
    
    i
      color #67c23a
      font-size 12px
    
    span
      background #f0f9ff
      padding 2px 6px
      border-radius 4px
      font-weight 500

// 状态设置样式
.status-settings
  .status-item
    display flex
    flex-direction column
    align-items center
    margin-bottom 8px
    
    .status-label
      font-size 11px
      color #909399
    margin-bottom 4px

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 规格配置样式
.spec-section
  margin-top 20px
  
  .spec-header
    display flex
    align-items center
    margin-bottom 12px
    cursor pointer
    color #409eff
    font-weight 600
    
    i
      margin-right 8px
      font-size 16px
      
      &:hover
        color #66b1ff
  
  .spec-table
    border-radius 8px
    overflow hidden
    
    /deep/ .el-table__header
      th
        background #f8f9fa
        color #303133
        font-weight 600
    
    .spec-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 16px
  
  .delete-btn
    color #f56c6c
    cursor pointer
    font-size 16px
    
    &:hover
      color #f78989

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-select
  .el-input__inner
    border-radius 6px

/deep/ .el-tag
  border-radius 6px
  font-weight 500

/deep/ .el-switch
  .el-switch__core
    border-radius 10px
</style>
